module.exports = __webpack_public_path__ + "img/ic_logo.a9f62770.png";